import classNames from 'classnames';
import { forwardRef } from 'react';
import TxtTitle from '../TxtTitle';
import FlexContainer from '../FlexContainer';
import ContentBlock from '../ContentBlock';
import View from '../View';
import styles from './ContentBlockTitled.module.scss';

/**
 * ContentBlock
 *
 * @return {JSX.Element}
 */
const ContentBlockTitled = (
  { className, title, children, rightContent, classNameBody, ...rest },
  ref
) => {
  return (
    <ContentBlock
      ref={ref}
      className={classNames(
        styles.ContentBlockTitled,
        className,
        `${ContentBlockTitled.displayName}`
      )}
      column
      {...rest}
    >
      <FlexContainer gap spaceBetween alignCenter className={styles.Header}>
        <View>
          <TxtTitle caption xx bold>
            {title}
          </TxtTitle>
        </View>
        {rightContent}
      </FlexContainer>
      <FlexContainer flex className={classNameBody}>
        {children}
      </FlexContainer>
    </ContentBlock>
  );
};

ContentBlockTitled.displayName = 'ContentBlockTitled';

export default forwardRef(ContentBlockTitled);
